






























































































































import Vue from 'vue'
import {LEVELUP_REQUIREMENT} from '@/common/constants'
import {INCREASE_ROUND, RESET, GAIN_EXP} from '@/common/mutation-types'
import {Effect} from '@/common/types'

export default Vue.extend({
  name: 'GameInfo',
  data() {
    return {
      showHelp: false,
      levelUpRequirement: LEVELUP_REQUIREMENT,
    }
  },
  computed: {
    gold(): number {
      return this.$store.state.gameInfo.gold
    },
    round(): number {
      return this.$store.state.gameInfo.round
    },
    level(): number {
      return this.$store.state.gameInfo.level
    },
    effects(): Effect {
      return this.$store.state.gameInfo.effects
    },
    onBattlefield(): number {
      return this.$store.state.gameInfo.battlefield.length
    },
    exp(): number {
      return this.$store.state.gameInfo.exp
    },
    hp(): number {
      return this.$store.state.gameInfo.hp
    },
  },
  methods: {
    increaseRound() {
      this.$store.dispatch(INCREASE_ROUND)
    },
    gainExp() {
      this.$store.commit(GAIN_EXP)
    },
    reset() {
      this.$store.commit(RESET)
    },
  },
})
